module.exports = __webpack_public_path__ + "static/media/empty_search_results_icon.c92aedca.svg";